import { useClaimHook } from 'hooks/claim.hook';
import { useGetServiceTypeInitials } from 'hooks/utils.hook';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import { Divider, TableBody, TableCell, TableRow, Typography } from 'styles';
import { IClaimComponents } from 'types/Claim';
import { formatPrice, getShortDate } from 'utils/utils';
import ClaimPaymentsTotal from './ClaimPaymentsTotal.component';

interface IClaimPaymentsBody {
	payments: IClaimComponents[];
}

const ClaimPaymentsBody = ({ payments }: IClaimPaymentsBody) => {
	const { claimData: claim } = useSelector((store: RootState) => store.claim);

	const { getInitialLabel } = useGetServiceTypeInitials();
	const { showTaxColumns } = useClaimHook();

	return (
		<TableBody className="claimPayments">
			{payments.map((row, index) => {
				const {
					retailAmount,
					serviceId,
					serviceName,
					contractualAdjustmentAmount,
					planPayAmount,
					allowablePlanPay,
					memberPayAmount,
					total,
					retailNetOfTax,
					tax,
					grossRetail,
					inStorePromotion,
				} = row;

				return (
					<TableRow key={index}>
						<TableCell scope="row">
							<Typography variant="body">{getShortDate(claim.claimDate)}</Typography>
						</TableCell>
						<TableCell align="center">
							<Typography variant="body">{serviceId || '-'}</Typography>
						</TableCell>
						<TableCell align="center">
							<Typography variant="body">{getInitialLabel(serviceName)}</Typography>
						</TableCell>
						<TableCell align="center">
							<Typography variant="body">
								{grossRetail ? formatPrice(grossRetail) : formatPrice('0.00')}
							</Typography>
						</TableCell>
						<TableCell align="center" />
						<TableCell align="center">
							<Typography variant="body">
								{inStorePromotion ? formatPrice(inStorePromotion) : formatPrice('0.00')}
							</Typography>
						</TableCell>
						<TableCell align="center" />
						<TableCell align="center">
							<Typography variant="body">
								{retailAmount ? formatPrice(retailAmount) : formatPrice('0.00')}
							</Typography>
						</TableCell>
						{showTaxColumns && (
							<>
								<TableCell align="center" />
								<TableCell
									align="center"
									sx={{ paddingTop: index === 0 ? '20px !important' : 'auto' }}
								>
									<Typography variant="body">
										{retailNetOfTax ? formatPrice(retailNetOfTax) : formatPrice('0.00')}
									</Typography>
								</TableCell>
								<TableCell align="center" />
								<TableCell
									align="center"
									sx={{ paddingTop: index === 0 ? '20px !important' : 'auto' }}
								>
									<Typography variant="body">
										{tax ? formatPrice(tax) : formatPrice('0.00')}
									</Typography>
								</TableCell>
							</>
						)}
						<TableCell align="center"></TableCell>
						<TableCell align="center">
							<Typography variant="body">
								{contractualAdjustmentAmount
									? formatPrice(contractualAdjustmentAmount)
									: formatPrice('0.00')}
							</Typography>
						</TableCell>
						<TableCell align="center">
							<Typography variant="body">
								{planPayAmount && allowablePlanPay
									? formatPrice(allowablePlanPay)
									: formatPrice('0.00')}
							</Typography>
						</TableCell>
						<TableCell align="center"></TableCell>
						<TableCell align="center">
							<Typography variant="body">
								{memberPayAmount ? formatPrice(memberPayAmount) : formatPrice('0.00')}
							</Typography>
						</TableCell>
						<TableCell align="center"></TableCell>
						<TableCell align="center">
							<Typography variant="body">
								{total ? formatPrice(total) : formatPrice('0.00')}
							</Typography>
						</TableCell>
					</TableRow>
				);
			})}

			<TableRow>
				<TableCell colSpan={showTaxColumns ? 19 : 15}>
					<Divider light sx={{ width: '100%', margin: 0 }} />
				</TableCell>
			</TableRow>

			<ClaimPaymentsTotal />
		</TableBody>
	);
};

export default ClaimPaymentsBody;
